import React, { createContext, useState, useEffect } from "react";
import axios from "axios";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const [userImage, setUserImage] = useState(null);

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (!token) return;

        axios
            .get(`${process.env.REACT_APP_API_BASE_URL}/user/profile`, {
                headers: { Authorization: `Bearer ${token}` },
            })
            .then((res) => {
                if (res.data.user?.profile_img) {
                    setUserImage(
                        `${process.env.REACT_APP_API_IMAGE_URL}/${res.data.user.profile_img}`
                    );
                }
            });
    }, []);

    return (
        <UserContext.Provider value={{ userImage, setUserImage }}>
            {children}
        </UserContext.Provider>
    );
};
